import * as CSS from 'csstype';
import { Config } from '../utils/prop-config';
import { Length, Token, t, transforms } from '../utils';

export const filter: Config = {
  filter: { transform: transforms.filter },
  blur: t.blur('--potion-blur'),
  brightness: t.propT('--potion-brightness', transforms.brightness),
  contrast: t.propT('--potion-contrast', transforms.contrast),
  hueRotate: t.degreeT('--potion-hue-rotate'),
  invert: t.propT('--potion-invert', transforms.invert),
  saturate: t.propT('--potion-saturate', transforms.saturate),
  dropShadow: t.propT('--potion-drop-shadow', transforms.dropShadow),
  backdropFilter: { transform: transforms.backdropFilter },
  backdropBlur: t.blur('--potion-backdrop-blur'),
  backdropBrightness: t.propT('--potion-backdrop-brightness', transforms.brightness),
  backdropContrast: t.propT('--potion-backdrop-contrast', transforms.contrast),
  backdropHueRotate: t.degreeT('--potion-backdrop-hue-rotate'),
  backdropInvert: t.propT('--potion-backdrop-invert', transforms.invert),
  backdropSaturate: t.propT('--potion-backdrop-saturate', transforms.saturate),
};

export interface FilterProps {
  /**
   * The CSS `filter` property. When set to `auto`, you allow
   * Coco UI to define the color based on the filter style props
   * (`blur`, `saturate`, etc.)
   */
  filter?: Token<CSS.Property.Filter | 'auto'>;
  /**
   * Sets the blur filter value of an element.
   * Value is assigned to `--potion-filter` css variable
   */
  blur?: Token<{}, 'blur'>;
  /**
   * Sets the brightness filter value of an element.
   * Value is assigned to `--potion-brightness` css variable
   */
  brightness?: Token<Length>;
  /**
   * Sets the constrast filter value of an element.
   * Value is assigned to `--potion-contrast` css variable
   */
  contrast?: Token<Length>;
  /**
   * Sets the hue-rotate filter value of an element.
   * Value is assigned to `--potion-hue-rotate` css variable
   */
  hueRotate?: Token<Length>;
  /**
   * Sets the invert filter value of an element.
   * Value is assigned to `--potion-invert` css variable
   */
  invert?: Token<Length>;
  /**
   * Sets the saturate filter value of an element.
   * Value is assigned to `--potion-saturate` css variable
   */
  saturate?: Token<Length>;
  /**
   * Sets the drop-shadow filter value of an element.
   * Value is assigned to `--potion-drop-shadow` css variable
   */
  dropShadow?: Token<CSS.Property.BoxShadow, 'shadows'>;
  /**
   * The CSS `backdrop-filter` property. When set to `auto`, you allow
   * coco UI to define the color based on the backdrop filter style props
   * (`backdropBlur`, `backdropSaturate`, etc.)
   */
  backdropFilter?: Token<CSS.Property.BackdropFilter | 'auto'>;
  /**
   * Sets the backdrop-blur filter value of an element.
   * Value is assigned to `--potion-backdrop-blur` css variable
   */
  backdropBlur?: Token<{}, 'blur'>;
  /**
   * Sets the backdrop-brightness filter value of an element.
   * Value is assigned to `--potion-backdrop-brightness` css variable
   */
  backdropBrightness?: Token<Length>;
  /**
   * Sets the backdrop-contrast filter value of an element.
   * Value is assigned to `--potion-backdrop-contrast` css variable
   */
  backdropContrast?: Token<Length>;
  /**
   * Sets the backdrop-hue-rotate filter value of an element.
   * Value is assigned to `--potion-backdrop-hue-rotate` css variable
   */
  backdropHueRotate?: Token<Length>;
  /**
   * Sets the backdrop-invert filter value of an element.
   * Value is assigned to `--potion-backdrop-invert` css variable
   */
  backdropInvert?: Token<Length>;
  /**
   * Sets the backdrop-saturate filter value of an element.
   * Value is assigned to `--potion-backdrop-saturate` css variable
   */
  backdropSaturate?: Token<Length>;
}
